import api from "../axios/axios-config";

export const getTreatments = async () => {
  try {
    let response = await api.get("treatment/listOfTreatment");
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const createTreatments = async (data) => {
  console.log({ data });
  try {
    let response = await api.post("treatment/createTreatment", data);

    return response?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const updateTreatments = async (dataId, data) => {
  try {
    let response = await api.post(
      "treatment/updateTreatment",
      {
        dataId,
        ...data,
      },
      
    );

    return response?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};
